var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.28882e-05 7.18149C-2.28882e-05 11.1424 3.25063 14.363 7.24855 14.363C8.89256 14.363 10.3871 13.817 11.6014 12.91L16.4681 17.7409C16.6362 17.9075 16.8697 18 17.1032 18C17.645 18 18 17.5928 18 17.1023C18 16.8617 17.9066 16.6396 17.7478 16.473L12.8998 11.6607C13.8993 10.4298 14.4971 8.87506 14.4971 7.18149C14.4971 3.22057 11.2465 0 7.24855 0C3.25063 0 -2.28882e-05 3.22057 -2.28882e-05 7.18149ZM1.2143 7.18149C1.2143 3.88689 3.92317 1.20308 7.24855 1.20308C10.5739 1.20308 13.2828 3.88689 13.2828 7.18149C13.2828 10.4761 10.5739 13.1599 7.24855 13.1599C3.92317 13.1599 1.2143 10.4761 1.2143 7.18149Z",
    fill: "#808084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.6464d1b650de3ed06467ddd3f0da4a26.svg";
export { ForwardRef as ReactComponent };